import { createContext } from 'react'

import { FilterableListBoxContextType } from './types'

export const FilterableListBoxContext = createContext<FilterableListBoxContextType>(
  {} as FilterableListBoxContextType,
)
